export enum TypeTicketCategory {
  MedicalAdvice = 'medical-advice',
  ProductAvailability = 'product-availability',
  ProductPrice = 'product-price',
  Prescription = 'prescription',
  SalesRepresentative = 'sales-representative',
  AppointmentScheduling = 'appointment-scheduling',
  Other = 'other',
}

export enum TicketCategory {
  MedicalAdvice = 'Medizinische Beratung',
  ProductAvailability = 'Produktverfügbarkeit',
  ProductPrice = 'Produktpreis',
  Prescription = 'Rezept',
  SalesRepresentative = 'Vertriebsmitarbeiter',
  AppointmentScheduling = 'Terminvereinbarung',
  Other = 'Sonstiges',
}
